import { moneyField } from 'src/lib/ValidatorHelper';
import * as Yup from 'yup';

const FundraisingMatchingValidator = () => Yup.object().shape({
  show_raised_amount: Yup.boolean(),
  //
  show_goal: Yup.boolean(),
  goal: moneyField()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .when('show_goal', {
      is: true,
      then: (schema) => schema.required('Admin fee is required'),
      otherwise: (schema) => schema,
    }),
  //
  bonus_round_active: Yup.boolean(),
  bonus_round_goal: moneyField()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .when('bonus_round_active', {
      is: true,
      then: (schema) => schema.required('Admin fee is required'),
      otherwise: (schema) => schema,
    }),
  active_matching: Yup.boolean(),
  matching_multiplier: Yup.mixed()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .test(
      'is-number',
      'must be a `number` type',
      (value) => value == null || (typeof value === 'number' && !Number.isNaN(value)),
    )
    .when('active_matching', {
      is: true,
      then: (schema: any) => schema.required('Required'),
      otherwise: (schema: any) => schema,
    }),
  start_amount_multiplier: Yup.mixed()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .test(
      'is-number',
      'must be a `number` type',
      (value) => value == null || (typeof value === 'number' && !Number.isNaN(value)),
    )
    .when('active_matching', {
      is: true,
      then: (schema: any) => schema.required('Required'),
      otherwise: (schema: any) => schema,
    }),
  end_amount_multiplier: Yup.mixed()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .test(
      'is-number',
      'must be a `number` type',
      (value) => value == null || (typeof value === 'number' && !Number.isNaN(value)),
    )
    .when('active_matching', {
      is: true,
      then: (schema: any) => schema.required('Required'),
      otherwise: (schema: any) => schema,
    }),
});

export default FundraisingMatchingValidator;
